import { HttpClient } from "@angular/common/http";
import {
  Component,
  HostListener,
  ViewChildren,
  QueryList,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { AppConfigService } from "src/app/services/app-config.service";
import { MmpConfirmPopupComponent } from "../mmp-confirm-popup/mmp-confirm-popup.component";
import { ExtractionService } from "src/app/shared/services/extraction.service";
import { EvaluationService } from "src/app/shared/services/evaluation.service";
import { EquivalencyService } from "src/app/shared/services/equivalency.service";
import { DataService } from "src/app/shared/services/data.service";
import { Subject } from "rxjs";
import { takeUntil, take } from "rxjs/operators";
import { MatTabGroup, MatTabsModule } from "@angular/material/tabs";
import { DashboardService } from "src/app/shared/services/dashboard.service";
import { FeedbackService } from "src/app/services/feedback.service";
import { ComparisonNormalizer } from "src/app/shared/utils/comparison-normalizer.util";
import { MmpMainHeaderComponent } from "../mmp-main-header/mmp-main-header.component";
import { MmpSubHeaderComponent } from "../mmp-sub-header/mmp-sub-header.component";
import { MmpLoaderComponent } from "../mmp-loader/mmp-loader.component";
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { CommonModule } from "@angular/common";
import { MmpExtractionComponent } from "../mmp-extraction/mmp-extraction.component";
import { MmpEvaluationComponent } from "../mmp-evaluation/mmp-evaluation.component";
import { MmpEquivalencyComponent } from "../mmp-equivalency/mmp-equivalency.component";
import {
  PreviewRotationDegrees,
  PreviewToolbarAnnotation,
  PreviewToolbarDirective,
  PreviewToolbarState,
} from "../../shared/directive/preview-toolbar.directive";
import {
  PreviewToolbarAction,
  PreviewToolbarComponent,
  PreviewZoomPreset,
} from "src/app/shared/components/preview-toolbar/preview-toolbar.component";
import * as DocxPreview from "docx-preview";

@Component({
  selector: "app-mmp-innerpage",
  templateUrl: "./mmp-innerpage.component.html",
  styleUrls: ["./mmp-innerpage.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    PdfJsViewerModule,
    MmpMainHeaderComponent,
    MmpSubHeaderComponent,
    MmpLoaderComponent,
    MmpExtractionComponent,
    MmpEvaluationComponent,
    MmpEquivalencyComponent,
    PreviewToolbarComponent,
    PreviewToolbarDirective,
  ],
})
export class MmpInnerpageComponent implements OnInit, OnDestroy, AfterViewInit {
  isResizing: boolean = false;
  startX: number = 0;
  startLeftWidth: number = 0;
  userTranscripts: any = [];
  activeTab: string = "";
  tabsState = {
    extraction: false,
    evaluation: false,
    equivalency: false,
  };
  completedState = {
    extraction: false,
    evaluation: false,
    equivalency: false,
  };
  loadedBlobs: Blob[] = [];
  loadingPdfIndex: number | null = null;
  pdfLoadErrorIndex: number | null = null;
  showConsoleLogs: boolean = false;
  showProspectDetailsLoader: boolean = false;
  showExtractionLoader: boolean = false;
  showEvaluationLoader: boolean = false;
  showEquivalencyLoader: boolean = false;
  selectedTranscriptIndex = 0;
  selectedVisibleIndex = 0;
  selectedVisibleIndexForChild = 0;
  hideSubheader: boolean = true;

  loaderInprogressText: string = "Extracting...";
  originPage: string = "";
  allCombineids: string[] = [];
  currentIndex: number = 0;
  combinedId: string = "";
  caseNumber: string = "";
  ComparisonNormalizer = ComparisonNormalizer;
  readonly defaultDocxPreviewState: PreviewToolbarState = {
    zoomLevel: 1,
    zoomMode: "pageWidth",
    fitScale: 1,
    rotationDegrees: 0,
    highlightModeEnabled: false,
    annotations: [],
    rendered: false,
  };
  docxPreviewStateByTranscript: Record<number, PreviewToolbarState> = {};

  private readonly destroy$ = new Subject<void>();

  @ViewChildren("pdfViewer", { read: ElementRef })
  pdfViewerElements!: QueryList<ElementRef<HTMLElement>>;
  @ViewChildren("pdfViewer") pdfViewers!: QueryList<any>;
  @ViewChildren("docxViewer", { read: ElementRef })
  docxViewerElements!: QueryList<ElementRef<HTMLElement>>;
  @ViewChild("rightContainer") rightContainer!: ElementRef;
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  @Output() resizeComplete = new EventEmitter<void>(); // Notify child components
  extractionInactiveIndexes: number[] = [];
  evaluationInactiveIndexes: number[] = [];
  extractionEditLocked: boolean = false;
  multiEquivalencyEditLocked: boolean = false;
  multiEquivalencyValidationLocked: boolean = false;
  private readonly viewerOriginalIndexMap = new WeakMap<any, number>();
  // Tracks the pending setTimeout ID for each viewer's iframe-refresh chain so that
  // rapid tab switches can cancel any in-flight chain before starting a new one.
  private readonly pendingRefreshTimers = new Map<
    HTMLElement,
    ReturnType<typeof setTimeout>
  >();
  // Debounce timer for stage tab clicks — prevents rapid clicking from triggering
  // multiple simultaneous tab-switch flows.
  private tabSwitchDebounceTimer: ReturnType<typeof setTimeout> | null = null;
  private readonly pdfViewerRetryCount = new Map<number, number>();
  dataAvailable: boolean = false;

  constructor(
    private readonly http: HttpClient,
    private readonly snackBar: MatSnackBar,
    private readonly envService: AppConfigService,
    private readonly route: ActivatedRoute,
    private readonly confirmPopup: MatDialog,
    private readonly router: Router,
    private readonly extractionService: ExtractionService,
    private readonly evaluationService: EvaluationService,
    private readonly equivalencyService: EquivalencyService,
    private readonly dashboardService: DashboardService,
    private readonly feedbackService: FeedbackService,
    private readonly appConfigService: AppConfigService,
    private readonly dataService: DataService,
  ) {}

  ngOnInit(): void {
    this.showConsoleLogs = this.envService.showConsoleLogs;

    const navState = history.state;
    this.originPage = navState.origin;

    // Case 1: Upload navigation
    if (ComparisonNormalizer.string(this.originPage) === "upload") {
      this.userTranscripts = navState.uploadData;
      this.initializeDocxPreviewStates();
      this.preloadAllPdfs();
      if (!this.userTranscripts) {
        this.router.navigate(["/user-transcripts"]);
      }
      this.startExtraction();
      return;
    }

    // Case 2: Dashboard navigation
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.combinedId = params.get("combinedId") ?? "";

      if (!this.combinedId) {
        this.showToast("toast-error", "Failed to load user details.");
        this.router.navigate(["/evaluator-dashboard"]);
        return;
      }

      this.originPage = "dashboard";
      this.showProspectDetailsLoader = true;

      this.dashboardService
        .fetchProspectsDetails(this.combinedId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.showProspectDetailsLoader = false;
            if (!res || !Array.isArray(res) || res.length === 0) {
              this.showToast("toast-error", "No prospect details found.");
              this.router.navigate(["/evaluator-dashboard"]);
              return;
            }
            this.clearPreviousData();
            this.userTranscripts = res[0].transcript;
            this.initializeDocxPreviewStates();
            this.preloadAllPdfs();
            this.caseNumber = res[0].case_number;
            this.dataAvailable = res[0].metadata_exists;

            // Clear cached blobs
            this.loadedBlobs = [];

            const studentDetails = {
              name: res[0].student_name,
              program: res[0].program,
              start_date: res[0].start_date,
              student_id: res[0].student_id,
            };

            this.extractionService.setStudentInformations(studentDetails);
            this.hideSubheader = false;
            if (this.showConsoleLogs) {
              console.log("userTranscripts", this.userTranscripts);
            }
            if (this.dataAvailable) {
              this.startMetaDataExtraction();
            } else {
              this.startExtraction();
            }

            // Wait for the ViewChildren to update (ngFor rendering) before loading the transcript
            const transcript = this.userTranscripts[0];
            if (this.isDocxTranscript(transcript)) {
              this.docxViewerElements.changes.pipe(take(1)).subscribe(() => {
                this.selectedVisibleIndex = 0;
                this.selectedVisibleIndexForChild = 0;
                this.loadDocxAtVisibleIndex(0);
              });
            } else {
              this.pdfViewers.changes.pipe(take(1)).subscribe(() => {
                this.selectedVisibleIndex = 0;
                this.selectedVisibleIndexForChild = 0;
                this.loadPdfAtIndex(0);
              });
            }
          },
          error: () => {
            this.showProspectDetailsLoader = false;
            this.showToast("toast-error", "Failed to load user details.");
          },
        });
    });
  }

  ngAfterViewInit(): void {
    // Load first transcript (PDF or DOCX)
    if (this.userTranscripts?.length) {
      const transcript = this.userTranscripts[0];
      if (this.isDocxTranscript(transcript)) {
        if (this.docxViewerElements?.length) {
          this.loadDocxAtVisibleIndex(0);
        } else {
          this.docxViewerElements.changes.pipe(take(1)).subscribe(() => {
            this.loadDocxAtVisibleIndex(0);
          });
        }
      } else {
        if (this.pdfViewers?.length) {
          this.loadPdfAtIndex(0);
        } else {
          this.pdfViewers.changes.pipe(take(1)).subscribe(() => {
            this.loadPdfAtIndex(0);
          });
        }
      }
    }
  }

  private isTranscriptVisible(index: number): boolean {
    const stage = ComparisonNormalizer.string(this.activeTab);
    if (stage === "evaluation") {
      return !this.extractionInactiveIndexes.includes(index);
    }
    if (stage === "equivalency") {
      return (
        !this.extractionInactiveIndexes.includes(index) &&
        !this.evaluationInactiveIndexes.includes(index)
      );
    }
    return true;
  }

  onEvaluationInactiveIndexes(localIndexes: number[]): void {
    const evaluationTranscripts =
      this.evaluationService.getEvaluationData()?.transcripts || [];
    const extractionTranscripts =
      this.extractionService.getExtractionData()?.transcripts || [];

    const sessionKeyToOriginalIndex = new Map<string, number>();
    extractionTranscripts.forEach((t: any, i: number) => {
      const key = ComparisonNormalizer.string(t?.session_key).trim();
      if (key) {
        sessionKeyToOriginalIndex.set(key, i);
      }
    });

    this.evaluationInactiveIndexes = localIndexes
      .map((idx) => {
        const key = ComparisonNormalizer.string(
          evaluationTranscripts[idx]?.session_key,
        ).trim();
        return sessionKeyToOriginalIndex.get(key) ?? -1;
      })
      .filter((i) => i !== -1);
  }

  private getVisibleIndices(): number[] {
    return this.userTranscripts
      .map((_, index) => index)
      .filter((index) => this.isTranscriptVisible(index));
  }

  private getOriginalIndexFromVisibleIndex(visibleIndex: number): number {
    const visibleIndices = this.getVisibleIndices();
    return visibleIndices[visibleIndex] ?? visibleIndex;
  }

  private getVisibleIndexFromOriginalIndex(originalIndex: number): number {
    const visibleIndices = this.getVisibleIndices();
    return visibleIndices.indexOf(originalIndex);
  }

  private loadPdfAtIndex(index: number): void {
    // Guard 1: transcripts list available
    if (!this.hasTranscriptsToLoad()) {
      return;
    }

    // Guard 2: index bounds
    if (index < 0 || index >= this.userTranscripts.length) {
      return;
    }

    const transcript = this.userTranscripts[index];

    // Guard 3: URL availability
    if (!this.hasTranscriptUrl(transcript, index)) {
      return;
    }

    // Guard 4: viewer context for this index
    const viewerContext = this.getPdfViewerContext(index);
    if (!viewerContext) {
      if (this.showConsoleLogs) {
        console.warn(
          `Aborting loadPdfAtIndex: no pdfViewer context found for original index ${index}. Waiting for viewers to initialize.`,
        );
      }
      // If viewers are not ready yet, wait for them to be rendered before retrying
      if (this.pdfViewers && this.pdfViewers.length > 0) {
        return;
      }
      this.pdfViewers.changes.pipe(take(1)).subscribe(() => {
        this.loadPdfAtIndex(index);
      });
      return;
    }

    const { pdfViewer, pdfElement } = viewerContext;

    const applyPdfToViewer = (blob: Blob) => {
      this.applyPdfBlobToViewer(pdfViewer, pdfElement, blob);
      // Mark the viewer mapping only after the blob is successfully applied.
      // This avoids stale mappings when fetch fails before apply.
      this.viewerOriginalIndexMap.set(pdfViewer, index);
    };

    // If we already have a cached Blob, reuse it instead of fetching again.
    const cachedBlob = this.loadedBlobs[index];
    if (cachedBlob) {
      applyPdfToViewer(cachedBlob);
      return;
    }

    // Otherwise, fetch from URL and apply.
    const pdfUrl = transcript.converted_url || transcript.transcript_blob_url;
    if (!pdfUrl) {
      return;
    }

    this.fetchAndApplyPdf(pdfUrl, index, applyPdfToViewer);
  }

  private hasTranscriptsToLoad(): boolean {
    if (this.userTranscripts?.length) {
      return true;
    }
    if (this.showConsoleLogs) {
      console.warn("No transcripts available to load.");
    }
    return false;
  }

  private hasTranscriptUrl(transcript: any, index: number): boolean {
    if (transcript?.converted_url || transcript?.transcript_blob_url) {
      return true;
    }
    if (this.showConsoleLogs) {
      console.error("Transcript or URL is undefined for index:", index);
    }
    return false;
  }

  private getPdfViewerContext(
    originalIndex: number,
  ): { pdfViewer: any; pdfElement: ElementRef } | null {
    if (!this.pdfViewers || !this.pdfViewerElements) {
      if (this.showConsoleLogs) {
        console.warn("PDF viewers not yet initialized.");
      }
      return null;
    }

    const pdfViewerPosition = this.getPdfViewerPosition(originalIndex);
    if (pdfViewerPosition === -1) {
      if (this.showConsoleLogs) {
        console.warn(`No PDF viewer context found for original index ${originalIndex}`);
      }
      return null;
    }

    const pdfViewer = this.pdfViewers.toArray()[pdfViewerPosition];
    const pdfElement = this.pdfViewerElements.toArray()[pdfViewerPosition];

    if (pdfViewer && pdfElement) {
      return { pdfViewer, pdfElement };
    }
    if (this.showConsoleLogs) {
      console.warn(
        `No pdfViewer or pdfElement for original index ${originalIndex}`,
        pdfViewer,
        pdfElement,
      );
    }
    return null;
  }

  private getPdfViewerPosition(originalIndex: number): number {
    const pdfElements = this.pdfViewerElements?.toArray() ?? [];

    const mappedPosition = pdfElements.findIndex(
      (pdfElement?: ElementRef<HTMLElement>) => {
      return (
          pdfElement?.nativeElement?.dataset["pdfIndex"] === `${originalIndex}`
      );
      },
    );

    if (mappedPosition !== -1) {
      return mappedPosition;
    }

    return originalIndex < pdfElements.length ? originalIndex : -1;
  }

  private applyPdfBlobToViewer(
    pdfViewer: any,
    pdfElement: ElementRef,
    blob: Blob,
  ): void {
    const hostEl = pdfElement.nativeElement as HTMLElement;

    if (!hostEl.isConnected) {
      if (this.showConsoleLogs) {
        console.warn(
          "applyPdfBlobToViewer: host element no longer in DOM, skipping apply.",
        );
      }
      return;
    }

    pdfViewer.pdfSrc = blob;

    this.waitForIframeAndRefresh(pdfViewer, pdfElement, blob);

    this.addOpenInNewTabButton(pdfElement, blob);
  }

  private waitForIframeAndRefresh(
    pdfViewer: any,
    pdfElement: ElementRef,
    blob: Blob,
  ): void {
    const hostEl = pdfElement.nativeElement as HTMLElement;

    // Cancel any in-flight refresh chain for this viewer.  Rapid tab switching
    // can stack multiple independent setTimeout chains; each would eventually
    // call pdfViewer.refresh(), triggering multiple PDF parse/render cycles and
    // the "Knockout groups not supported" warning from pdf.mjs.  Cancelling the
    // previous chain ensures only the latest request ever calls refresh().
    const existingTimer = this.pendingRefreshTimers.get(hostEl);
    if (existingTimer !== undefined) {
      clearTimeout(existingTimer);
      this.pendingRefreshTimers.delete(hostEl);
    }

    let attempts = 0;
    const maxAttempts = 20;

    const scheduleNext = () => {
      const id = setTimeout(tryRefresh, 100);
      this.pendingRefreshTimers.set(hostEl, id);
    };

    const tryRefresh = () => {
      this.pendingRefreshTimers.delete(hostEl);
      attempts++;

      // Check if the host element is still in the DOM
      if (!document.body.contains(hostEl)) {
        if (this.showConsoleLogs) {
          console.warn(
            "PDF host element no longer in DOM (attempt " +
              attempts +
              "); skip refresh.",
          );
        }
        return;
      }

      const iframe = hostEl.querySelector("iframe");
      if (iframe && typeof pdfViewer.refresh === "function") {
        try {
          pdfViewer.refresh();
          this.addOpenInNewTabButton(pdfElement, blob);
        } catch (e) {
          if (this.showConsoleLogs) {
            console.error("Error calling pdfViewer.refresh()", e);
          }
        }
      } else if (attempts < maxAttempts) {
        scheduleNext();
      } else if (this.showConsoleLogs) {
        console.warn("Iframe not available for pdfViewer; refresh skipped.");
      }
    };

    scheduleNext();
  }

  private fetchAndApplyPdf(
    transcriptBlobUrl: string,
    index: number,
    applyPdfToViewer: (blob: Blob) => void,
  ): void {
    try {
      this.http
        .get(transcriptBlobUrl, { responseType: "blob" })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (blob: Blob) => {
            this.loadedBlobs[index] = blob;
            applyPdfToViewer(blob);
          },
          error: (err) => {
            if (this.showConsoleLogs) {
              console.log("Pdf Viewer error:", err);
            }
            this.showToast(
              "toast-error",
              "Failed to load this Transcript. Please contact Admin.",
            );
          },
          complete: () => {},
        });
    } catch (err) {
      if (this.showConsoleLogs) {
        console.error("Unexpected error loading PDF:", err);
      }
    }
  }

  private fetchAndRenderDocx(
    docxBlobUrl: string,
    index: number,
    containerElement: ElementRef,
  ): void {
    this.updateDocxRenderedState(index, false);

    try {
      this.http
        .get(docxBlobUrl, { responseType: "blob" })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (blob: Blob) => {
            this.loadedBlobs[index] = blob;
            this.renderDocxInContainer(blob, containerElement, index);
          },
          error: (err) => {
            this.updateDocxRenderedState(index, false);
            if (this.showConsoleLogs) {
              console.log("Docx Viewer error:", err);
            }
            this.showToast(
              "toast-error",
              "Failed to load this Transcript. Please contact Admin.",
            );
          },
          complete: () => {},
        });
    } catch (err) {
      this.updateDocxRenderedState(index, false);
      if (this.showConsoleLogs) {
        console.error("Unexpected error loading DOCX:", err);
      }
    }
  }

  private renderDocxInContainer(
    blob: Blob,
    containerElement: ElementRef,
    transcriptIndex: number,
  ): void {
    const container = containerElement.nativeElement as HTMLElement;

    if (!container.isConnected) {
      this.updateDocxRenderedState(transcriptIndex, false);
      if (this.showConsoleLogs) {
        console.warn("Docx container no longer in DOM, skipping render.");
      }
      return;
    }

    // Clear previous content
    container.innerHTML = "";

    this.updateDocxRenderedState(transcriptIndex, false);

    DocxPreview.renderAsync(blob, container)
      .then(() => {
        this.updateDocxRenderedState(transcriptIndex, true);
      })
      .catch((err) => {
        this.updateDocxRenderedState(transcriptIndex, false);
        if (this.showConsoleLogs) {
          console.error("Error rendering DOCX:", err);
        }
      });
  }

  onMouseDown(event: MouseEvent): void {
    this.isResizing = true;
    this.startX = event.clientX;
    const leftContainer = document.querySelector(".left-container");
    this.startLeftWidth = (leftContainer as HTMLElement)?.offsetWidth;
  }

  @HostListener("window:mousemove", ["$event"])
  onMouseMove(event: MouseEvent): void {
    if (!this.isResizing) return;

    const dx = event.clientX - this.startX;
    const leftContainer =
      document.querySelector<HTMLElement>(".left-container");

    const rightContainer =
      document.querySelector<HTMLElement>(".right-container");

    const bodyContainer =
      document.querySelector<HTMLElement>(".body-container");

    if (!leftContainer || !rightContainer || !bodyContainer) {
      return;
    }

    const bodyWidth = bodyContainer?.offsetWidth || 0;
    const newLeftWidth = (this.startLeftWidth || 0) + dx;

    // Ensure the left container does not exceed the body width or go below a minimum width
    if (newLeftWidth > 50 && newLeftWidth < bodyWidth - 50) {
      leftContainer.style.flex = `0 0 ${newLeftWidth}px`;
      rightContainer.style.flex = `0 0 ${bodyWidth - newLeftWidth - 10}px`; // Adjust for divider width

      const iframes = leftContainer.querySelectorAll("iframe");
      iframes.forEach((iframe) => (iframe.style.pointerEvents = "none"));
    }

    if (this.tabGroup?._tabHeader) {
      this.tabGroup._tabHeader.updatePagination();
    }
  }

  @HostListener("window:mouseup")
  onMouseUp(): void {
    this.isResizing = false;

    const leftContainer =
      document.querySelector<HTMLElement>(".left-container");
    const iframes = leftContainer?.querySelectorAll("iframe") || [];
    iframes.forEach((iframe) => (iframe.style.pointerEvents = "auto"));

    // Notify child components that resizing is complete
    this.resizeComplete.emit();
  }

  processTabClick(stage: string): void {
    if (
      this.isProcessTabDisabled(
        stage as "extraction" | "evaluation" | "equivalency",
      )
    ) {
      return;
    }

    // Debounce rapid clicks: cancel any pending switch and wait 300 ms of
    // inactivity before committing.  This prevents stacked PDF-load chains
    // when the user clicks across tabs quickly.
    if (this.tabSwitchDebounceTimer !== null) {
      clearTimeout(this.tabSwitchDebounceTimer);
    }
    this.tabSwitchDebounceTimer = setTimeout(() => {
      this.tabSwitchDebounceTimer = null;
      this.applyTabSwitch(stage);
    }, 300);
  }

  private applyTabSwitch(stage: string) {
    this.activeTab = stage;

    let reset = false;

    for (const key in this.completedState) {
      if (
        ComparisonNormalizer.string(key) === ComparisonNormalizer.string(stage)
      ) {
        reset = true;
      }

      if (reset) {
        this.completedState[key] = false;
      } else {
        this.completedState[key] = true;
      }
    }

    this.selectedVisibleIndex = 0;
    this.selectedTranscriptIndex = 0;

    // Allow mat-tab-group to rebuild after @if changes
    setTimeout(() => {
      this.tabGroup.selectedIndex = 0;
    });
  }

  disableTabClickFrom(stage: string) {
    let reset = true;
    for (const key in this.tabsState) {
      if (reset) {
        this.tabsState[key] = true;
      } else {
        this.tabsState[key] = false;
        if (ComparisonNormalizer.string(key) === "evaluation") {
          this.evaluationService.clearEvaluationResult();
        }
        if (ComparisonNormalizer.string(key) === "equivalency") {
          this.equivalencyService.clearEquivalencyResult();
        }
      }
      if (
        ComparisonNormalizer.string(key) === ComparisonNormalizer.string(stage)
      ) {
        reset = false;
      }
    }
  }

  disableAllTabs(locked?: boolean): void {
    if (locked === true) {
      this.multiEquivalencyValidationLocked = true;
      return;
    }

    if (locked === false) {
      this.multiEquivalencyValidationLocked = false;
      return;
    }

    // Set all tabs in the tabsState object to false
    for (const key in this.tabsState) {
      if (this.tabsState.hasOwnProperty(key)) {
        this.tabsState[key] = false;
      }
    }
    this.completedState = {
      extraction: false,
      evaluation: false,
      equivalency: false,
    };
  }

  onTranscriptTabChange(event: any) {
    const visibleIndex = event.index;

    this.selectedVisibleIndex = visibleIndex;
    this.selectedTranscriptIndex = visibleIndex;

    setTimeout(() => {
      const originalIndex = this.getOriginalIndexFromVisibleIndex(visibleIndex);
      const transcript = this.userTranscripts[originalIndex];

      if (this.isDocxTranscript(transcript)) {
        this.loadDocxAtVisibleIndex(visibleIndex);
      } else {
        this.loadPdfAtVisibleIndex(visibleIndex);
      }
    }, 0);
  }

  onTranscriptTabClick(event: any) {
    setTimeout(() => {
      this.selectedVisibleIndexForChild = this.selectedVisibleIndex;
    }, 10);
  }

  private loadPdfAtVisibleIndex(visibleIndex: number): void {
    if (!this.pdfViewers || !this.pdfViewerElements) {
      return;
    }

    const originalIndex = this.getOriginalIndexFromVisibleIndex(visibleIndex);
    const viewerContext = this.getPdfViewerContext(originalIndex);

    if (!viewerContext) {
      return;
    }

    const { pdfViewer, pdfElement } = viewerContext;

    // Angular Material mat-tab can recreate tab bodies after stage changes.
    // The QueryList can contain the viewer before its host is attached.
    // Retry by fetching a fresh reference on every frame.
    if (!pdfElement.nativeElement.isConnected) {
      const retryCount = this.pdfViewerRetryCount.get(visibleIndex) ?? 0;

      if (retryCount < 5) {
        this.pdfViewerRetryCount.set(visibleIndex, retryCount + 1);

        requestAnimationFrame(() => {
          this.loadPdfAtVisibleIndex(visibleIndex);
        });
      } else {
        this.pdfViewerRetryCount.delete(visibleIndex);

        if (this.showConsoleLogs) {
          console.error(
            `PDF viewer failed to attach after retries for index ${visibleIndex}`,
          );
        }
      }

      return;
    }

    this.pdfViewerRetryCount.delete(visibleIndex);

    const transcript = this.userTranscripts[originalIndex];

    if (!this.hasTranscriptUrl(transcript, originalIndex)) {
      return;
    }

    // Avoid resetting the same viewer unnecessarily
    if (
      this.viewerOriginalIndexMap.get(pdfViewer) === originalIndex &&
      pdfViewer.pdfSrc
    ) {
      return;
    }

    const applyPdfToViewer = (blob: Blob) => {
      this.applyPdfBlobToViewer(pdfViewer, pdfElement, blob);

      this.viewerOriginalIndexMap.set(pdfViewer, originalIndex);
    };

    if (this.loadedBlobs[originalIndex]) {
      applyPdfToViewer(this.loadedBlobs[originalIndex]);
      return;
    }

    this.fetchAndApplyPdf(
      transcript.converted_url || transcript.transcript_blob_url,
      originalIndex,
      applyPdfToViewer,
    );
  }

  private loadDocxAtVisibleIndex(visibleIndex: number): void {
    if (!this.docxViewerElements) {
      return;
    }

    const originalIndex = this.getOriginalIndexFromVisibleIndex(visibleIndex);
    const docxElement = this.getDocxViewerElement(originalIndex);

    if (!docxElement) {
      return;
    }

    // Angular Material mat-tab can recreate tab bodies after stage changes.
    // Retry by fetching a fresh reference on every frame.
    if (!docxElement.nativeElement.isConnected) {
      const retryCount = this.pdfViewerRetryCount.get(visibleIndex) ?? 0;

      if (retryCount < 5) {
        this.pdfViewerRetryCount.set(visibleIndex, retryCount + 1);

        requestAnimationFrame(() => {
          this.loadDocxAtVisibleIndex(visibleIndex);
        });
      } else {
        this.pdfViewerRetryCount.delete(visibleIndex);

        if (this.showConsoleLogs) {
          console.error(
            `DOCX viewer failed to attach after retries for index ${visibleIndex}`,
          );
        }
      }

      return;
    }

    this.pdfViewerRetryCount.delete(visibleIndex);
    this.ensureDocxPreviewState(originalIndex);

    const transcript = this.userTranscripts[originalIndex];

    if (!this.hasTranscriptUrl(transcript, originalIndex)) {
      return;
    }

    // Use cached blob if available
    if (this.loadedBlobs[originalIndex]) {
      this.renderDocxInContainer(
        this.loadedBlobs[originalIndex],
        docxElement,
        originalIndex,
      );
      return;
    }

    this.fetchAndRenderDocx(
      transcript.converted_url || transcript.transcript_blob_url,
      originalIndex,
      docxElement,
    );
  }

  onChildTabChange(newVisibleIndex: number) {
    // Guard against programmatic echoes: when the child component receives a new
    // @Input (selectedTranscriptIndex) its mat-tab-group fires selectedTabChange
    // and the component emits back the same index.  If selectedVisibleIndex already
    // matches there is nothing to change, so bail out to prevent a feedback loop.
    if (newVisibleIndex === this.selectedVisibleIndex) {
      return;
    }
    this.selectedVisibleIndex = newVisibleIndex;
    this.selectedTranscriptIndex = newVisibleIndex; // Keep in sync as visible index
  }

  onDocxToolbarAction(
    transcriptIndex: number,
    action: PreviewToolbarAction,
  ): void {
    switch (action) {
      case "zoomOut":
        this.updateDocxZoom(transcriptIndex, -1);
        return;
      case "zoomIn":
        this.updateDocxZoom(transcriptIndex, 1);
        return;
      case "toggleHighlight": {
        const previewState = this.ensureDocxPreviewState(transcriptIndex);
        this.setDocxPreviewState(transcriptIndex, {
          ...previewState,
          highlightModeEnabled: !previewState.highlightModeEnabled,
        });
        return;
      }
      case "rotateLeft":
        this.updateDocxRotation(transcriptIndex, -90);
        return;
      case "rotateRight":
        this.updateDocxRotation(transcriptIndex, 90);
        return;
      case "print":
        this.printDocxTranscript(transcriptIndex);
        return;
      case "download":
        this.downloadDocxTranscript(transcriptIndex);
        return;
      default:
        return;
    }
  }

  onDocxZoomPresetChange(
    transcriptIndex: number,
    zoomPreset: PreviewZoomPreset,
  ): void {
    const previewState = this.ensureDocxPreviewState(transcriptIndex);

    switch (zoomPreset) {
      case "automatic":
      case "pageFit":
      case "pageWidth":
        this.setDocxPreviewState(transcriptIndex, {
          ...previewState,
          zoomMode: zoomPreset,
        });
        return;
      case "actualSize":
        this.setDocxPreviewState(transcriptIndex, {
          ...previewState,
          zoomMode: "actualSize",
          zoomLevel: 1,
        });
        return;
      default:
        this.setDocxPreviewState(transcriptIndex, {
          ...previewState,
          zoomMode: "custom",
          zoomLevel: Number(zoomPreset),
        });
        return;
    }
  }

  onDocxFitScaleChange(transcriptIndex: number, fitScale: number): void {
    const previewState = this.ensureDocxPreviewState(transcriptIndex);
    if (Math.abs(previewState.fitScale - fitScale) <= 0.0001) {
      return;
    }

    this.setDocxPreviewState(transcriptIndex, {
      ...previewState,
      fitScale,
    });
  }

  onDocxAnnotationChange(
    transcriptIndex: number,
    annotations: PreviewToolbarAnnotation[],
  ): void {
    const previewState = this.ensureDocxPreviewState(transcriptIndex);
    this.setDocxPreviewState(transcriptIndex, {
      ...previewState,
      annotations,
    });
  }

  private isDocxTranscript(transcript: any): boolean {
    return ComparisonNormalizer.string(transcript?.transcript_file_name)
      .toLowerCase()
      .endsWith(".docx");
  }

  private initializeDocxPreviewStates(): void {
    const nextDocxPreviewState: Record<number, PreviewToolbarState> = {};

    this.userTranscripts.forEach((transcript: any, index: number) => {
      if (this.isDocxTranscript(transcript)) {
        nextDocxPreviewState[index] =
          this.docxPreviewStateByTranscript[index] ??
          this.createDefaultDocxPreviewState();
      }
    });

    this.docxPreviewStateByTranscript = nextDocxPreviewState;
  }

  private createDefaultDocxPreviewState(): PreviewToolbarState {
    return {
      ...this.defaultDocxPreviewState,
      annotations: [],
    };
  }

  private ensureDocxPreviewState(
    transcriptIndex: number,
  ): PreviewToolbarState {
    const existingState = this.docxPreviewStateByTranscript[transcriptIndex];
    if (existingState) {
      return existingState;
    }

    const previewState = this.createDefaultDocxPreviewState();
    this.setDocxPreviewState(transcriptIndex, previewState);
    return previewState;
  }

  private setDocxPreviewState(
    transcriptIndex: number,
    previewState: PreviewToolbarState,
  ): void {
    this.docxPreviewStateByTranscript = {
      ...this.docxPreviewStateByTranscript,
      [transcriptIndex]: previewState,
    };
  }

  private updateDocxZoom(transcriptIndex: number, direction: 1 | -1): void {
    const previewState = this.ensureDocxPreviewState(transcriptIndex);
    const currentZoomLevel = this.getEffectiveDocxZoomLevel(previewState);
    const nextZoomLevel = Math.min(
      4,
      Math.max(0.5, Number((currentZoomLevel + direction * 0.1).toFixed(2))),
    );

    this.setDocxPreviewState(transcriptIndex, {
      ...previewState,
      zoomMode: "custom",
      zoomLevel: nextZoomLevel,
    });
  }

  private getEffectiveDocxZoomLevel(
    previewState: PreviewToolbarState,
  ): number {
    switch (previewState.zoomMode) {
      case "actualSize":
        return 1;
      case "custom":
        return previewState.zoomLevel;
      case "automatic":
      case "pageFit":
      case "pageWidth":
      default:
        return previewState.fitScale;
    }
  }

  private updateDocxRotation(
    transcriptIndex: number,
    delta: 90 | -90,
  ): void {
    const previewState = this.ensureDocxPreviewState(transcriptIndex);
    const nextRotation =
      (previewState.rotationDegrees + delta + 360) % 360;

    this.setDocxPreviewState(transcriptIndex, {
      ...previewState,
      rotationDegrees: nextRotation as PreviewRotationDegrees,
    });
  }

  private updateDocxRenderedState(
    transcriptIndex: number,
    rendered: boolean,
  ): void {
    const previewState = this.ensureDocxPreviewState(transcriptIndex);
    this.setDocxPreviewState(transcriptIndex, {
      ...previewState,
      rendered,
    });
  }

  private printDocxTranscript(transcriptIndex: number): void {
    const container = this.getDocxViewerElement(transcriptIndex)?.nativeElement;
    if (!container?.isConnected) {
      return;
    }

    const printWindow = globalThis.open("", "_blank", "width=1024,height=768");
    if (!printWindow) {
      return;
    }

    const clonedContainer = container.cloneNode(true) as HTMLElement;
    this.applyDocxPrintStyles(container, clonedContainer);
    const printDocument = printWindow.document;
    const titleElement = printDocument.createElement("title");
    const styleElement = printDocument.createElement("style");
    styleElement.textContent = `
      html, body {
        margin: 0;
        padding: 0;
        background: #fff;
      }
      @page {
        margin: 0;
      }
      .docxContainer {
        color: #000;
        background: #fff;
        overflow: visible !important;
      }
      mark[data-preview-annotation-id],
      .docx-preview-draw-layer path {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      @media print {
        body {
          padding: 0;
        }
      }
    `;

    titleElement.textContent = "Print Transcript";
    printDocument.head.replaceChildren(titleElement, styleElement);
    printDocument.body.replaceChildren(clonedContainer);
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  }

  private applyDocxPrintStyles(
    sourceContainer: HTMLElement,
    clonedContainer: HTMLElement,
  ): void {
    const computedStyles = globalThis.getComputedStyle(sourceContainer);
    const highlightBackground = computedStyles.getPropertyValue(
      "--docx-highlight-background",
    );
    const highlightColor = computedStyles.getPropertyValue(
      "--docx-highlight-color",
    );

    if (highlightBackground.trim().length > 0) {
      clonedContainer.style.setProperty(
        "--docx-highlight-background",
        highlightBackground.trim(),
      );
    }

    if (highlightColor.trim().length > 0) {
      clonedContainer.style.setProperty(
        "--docx-highlight-color",
        highlightColor.trim(),
      );
    }

    clonedContainer.style.padding = "0";
    clonedContainer.style.boxSizing = "border-box";
    clonedContainer.style.height = "auto";
    clonedContainer.style.overflow = "visible";
    clonedContainer.style.backgroundColor = "#fff";

    const sourceWrapper = sourceContainer.querySelector<HTMLElement>(
      ".docx-preview-wrapper",
    );
    const clonedWrapper = clonedContainer.querySelector<HTMLElement>(
      ".docx-preview-wrapper",
    );

    if (sourceWrapper && clonedWrapper) {
      this.copyLayoutStyles(sourceWrapper, clonedWrapper, [
        "display",
        "min-width",
        "width",
        "height",
        "position",
        "transform",
        "transform-origin",
        "box-sizing",
      ]);

      clonedWrapper.style.margin = "0";
      clonedWrapper.style.padding = "0";
    }

    this.copyLayoutStylesForSelector(
      sourceContainer,
      clonedContainer,
      ".docx-wrapper, .docx",
      [
        "display",
        "margin",
        "padding",
        "overflow",
        "width",
        "height",
        "box-sizing",
      ],
    );

    this.copyLayoutStylesForSelector(sourceContainer, clonedContainer, "img, canvas", [
      "display",
      "margin",
      "padding",
      "width",
      "height",
      "max-width",
      "box-sizing",
      "object-fit",
    ]);

    clonedContainer
      .querySelectorAll<SVGSVGElement>(".docx-preview-draw-layer")
      .forEach((drawLayer, index) => {
        const sourceDrawLayer = sourceContainer.querySelectorAll<SVGSVGElement>(
          ".docx-preview-draw-layer",
        )[index];

        if (sourceDrawLayer) {
          this.copyLayoutStyles(sourceDrawLayer, drawLayer, [
            "position",
            "inset",
            "top",
            "right",
            "bottom",
            "left",
            "width",
            "height",
            "overflow",
            "z-index",
            "mix-blend-mode",
          ]);
        }

        drawLayer.style.overflow = "visible";
      });
  }

  private copyLayoutStylesForSelector(
    sourceRoot: HTMLElement,
    targetRoot: HTMLElement,
    selector: string,
    styleProperties: string[],
  ): void {
    const sourceElements = sourceRoot.querySelectorAll<HTMLElement>(selector);
    const targetElements = targetRoot.querySelectorAll<HTMLElement>(selector);

    sourceElements.forEach((sourceElement, index) => {
      const targetElement = targetElements[index];
      if (targetElement) {
        this.copyLayoutStyles(sourceElement, targetElement, styleProperties);
      }
    });
  }

  private copyLayoutStyles(
    sourceElement: Element,
    targetElement: Element,
    styleProperties: string[],
  ): void {
    const computedStyles = globalThis.getComputedStyle(sourceElement);
    const targetStyle = (targetElement as HTMLElement | SVGElement).style;
    const sourceStyle = (sourceElement as HTMLElement | SVGElement).style;

    styleProperties.forEach((propertyName) => {
      const inlineValue = sourceStyle.getPropertyValue(propertyName);
      const computedValue = computedStyles.getPropertyValue(propertyName);
      const valueToApply = inlineValue || computedValue;

      if (valueToApply) {
        targetStyle.setProperty(propertyName, valueToApply);
      }
    });
  }

  private downloadDocxTranscript(transcriptIndex: number): void {
    const transcript = this.userTranscripts[transcriptIndex];
    if (!transcript) {
      return;
    }

    const fileName = this.getTranscriptFileName(transcript, transcriptIndex);
    const cachedBlob = this.loadedBlobs[transcriptIndex];
    if (cachedBlob) {
      this.triggerBlobDownload(cachedBlob, fileName);
      return;
    }

    const fileUrl = transcript.converted_url || transcript.transcript_blob_url;
    if (!fileUrl) {
      return;
    }

    this.http
      .get(fileUrl, { responseType: "blob" })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (blob: Blob) => {
          this.loadedBlobs[transcriptIndex] = blob;
          this.triggerBlobDownload(blob, fileName);
        },
        error: () => {
          this.showToast(
            "toast-error",
            "Failed to download this Transcript. Please contact Admin.",
          );
        },
      });
  }

  private getTranscriptFileName(
    transcript: any,
    transcriptIndex: number,
  ): string {
    return transcript?.transcript_file_name || `Transcript ${transcriptIndex + 1}.docx`;
  }

  private triggerBlobDownload(blob: Blob, fileName: string): void {
    const downloadUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = downloadUrl;
    anchor.download = fileName;
    anchor.rel = "noopener";
    anchor.click();
    URL.revokeObjectURL(downloadUrl);
  }

  private getDocxViewerElement(transcriptIndex: number): ElementRef | null {
    const docxElements = this.docxViewerElements?.toArray() ?? [];

    const mappedElement = docxElements.find(
      (docxElement: ElementRef<HTMLElement>) => {
      return (
          docxElement.nativeElement?.dataset["docxIndex"] ===
          `${transcriptIndex}`
      );
      },
    );

    if (mappedElement) {
      return mappedElement;
    }

    return docxElements[transcriptIndex] ?? null;
  }

  private addOpenInNewTabButton(pdfElement: ElementRef, pdfBlob: Blob) {
    setTimeout(() => {
      try {
        const host = pdfElement.nativeElement;
        const iframe = host.querySelector("iframe");
        if (!iframe) return;

        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow?.document;
        if (!iframeDoc) return;

        if (iframeDoc.getElementById("openInNewTabBtn")) return;

        const toolbar = iframeDoc.querySelector("#toolbarViewerRight");
        if (!toolbar) return;

        const btn = iframeDoc.createElement("button");
        btn.id = "openInNewTabBtn";
        btn.title = "Open in New Tab";
        btn.style.fontSize = "16px";
        btn.style.margin = "5px 15px 0px -4px";
        btn.style.cursor = "pointer";
        btn.style.border = "none";
        btn.style.background = "transparent";

        // --- Create SVG icon via DOM APIs (no innerHTML) ---
        const svgNS = "http://www.w3.org/2000/svg";
        const svg = iframeDoc.createElementNS(svgNS, "svg");
        svg.setAttribute("width", "18");
        svg.setAttribute("height", "18");
        svg.setAttribute("viewBox", "0 0 18 18");
        svg.setAttribute("fill", "none");

        const path = iframeDoc.createElementNS(svgNS, "path");
        path.setAttribute(
          "d",
          "M15 10.5V12.6C15 13.4401 15 13.8602 14.8365 14.181C14.6927 14.4632 14.4632 14.6927 14.181 14.8365C13.8602 15 13.4401 15 12.6 15H5.12037C4.03279 15 3.14455 14.1309 3.12084 13.0436L3 7.5V5.4C3 4.55992 3 4.13988 3.16349 3.81902C3.3073 3.53677 3.53677 3.3073 3.81902 3.16349C4.13988 3 4.55992 3 5.4 3H7.5M11.25 6.75L15.75 2.25M15.75 2.25H11.25M15.75 2.25V6.75",
        );
        path.setAttribute("stroke", "#5B5B5B");
        path.setAttribute("stroke-width", "1.5");
        path.setAttribute("stroke-linecap", "round");
        path.setAttribute("stroke-linejoin", "round");

        svg.appendChild(path);
        btn.appendChild(svg);
        // --- End SVG creation ---

        btn.onclick = () => {
          const blobUrl = URL.createObjectURL(pdfBlob);
          window.open(blobUrl, "_blank");
        };

        toolbar.appendChild(btn);
      } catch (e) {
        if (this.showConsoleLogs) {
          console.error("Failed to add Open in New Tab button", e);
        }
      }
    }, 500);
  }

  showToast(type: string, message: string) {
    this.snackBar.open(message, "x", {
      duration: 3000,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: [type],
    });
  }

  startMetaDataExtraction() {
    this.showExtractionLoader = true;
    this.activeTab = "extraction";
    this.dataService.startWebSocket(this.combinedId);
    this.dataService.state$
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        if (state === "extraction") {
          this.startExtraction();
        }
        if (state === "evaluation") {
          this.extractionService.hiddenIndexesEvaluation$
            .pipe(takeUntil(this.destroy$))
            .subscribe((hiddenIndexes: number[]) => {
              this.extractionInactiveIndexes = hiddenIndexes;
            });
          this.startEvaluation();
        }
        if (state === "equivalency") {
          this.evaluationService.hiddenIndexesEquivalency$
            .pipe(takeUntil(this.destroy$))
            .subscribe((hiddenIndexes: number[]) => {
              this.evaluationInactiveIndexes = hiddenIndexes;
            });
          this.startEquivalency();
        }
      });
  }

  startExtraction() {
    if (!this.dataAvailable) {
      this.extractionService.startWebSocket(
        this.userTranscripts,
        this.combinedId,
        this.originPage,
        this.caseNumber,
      );
    }

    this.showExtractionLoader = true;
    this.activeTab = "extraction";
    this.tabsState.extraction = true;
    this.extractionService.transcripts$
      .pipe(takeUntil(this.destroy$))
      .subscribe((transcripts) => {
        const isExtracting = transcripts.some(
          (t) => ComparisonNormalizer.string(t.status) === "completed",
        );

        this.showExtractionLoader = !isExtracting;
        if (ComparisonNormalizer.string(this.originPage) !== "dashboard") {
          this.hideSubheader = !isExtracting;
        }
      });
  }

  startEvaluationWebsocket() {
    if (!this.evaluationService.getEvaluationData()) {
      this.evaluationService.startWebSocket();
    }
    this.startEvaluation();
  }
  startEvaluation() {
    this.loaderInprogressText = "Evaluating...";
    this.showEvaluationLoader = true;
    this.rightContainer.nativeElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.activeTab = "evaluation";
    this.tabsState.evaluation = true;
    this.completedState.extraction = true;

    this.evaluationService.evaluationResult$
      .pipe(takeUntil(this.destroy$))
      .subscribe((transcripts) => {
        const isEvaluating = transcripts.some(
          (t) => ComparisonNormalizer.string(t.status) === "completed",
        );

        this.showEvaluationLoader = !isEvaluating;
      });

    this.selectedVisibleIndex = 0;
    this.selectedTranscriptIndex = 0;
  }

  startEquivalencyWebsocket() {
    if (!this.equivalencyService.getEquivalencyData()) {
      this.equivalencyService.startWebSocket();
    }
    this.startEquivalency();
  }

  startEquivalency() {
    this.loaderInprogressText = "Equating...";
    this.showEquivalencyLoader = true;
    this.rightContainer.nativeElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.activeTab = "equivalency";
    this.tabsState.equivalency = true;
    this.completedState.evaluation = true;
    this.equivalencyService.equivalencyResult$
      .pipe(takeUntil(this.destroy$))
      .subscribe((transcripts) => {
        const isEvaluating = transcripts.some(
          (t) => ComparisonNormalizer.string(t.status) === "completed",
        );

        this.showEquivalencyLoader = !isEvaluating;
      });
    this.selectedVisibleIndex = 0;
    this.selectedTranscriptIndex = 0;
  }

  reuploadTranscript() {
    const dialogRef = this.confirmPopup.open(MmpConfirmPopupComponent, {
      width: "600px",
      data: {
        title: "Re-upload Transcript",
        message: "Are you sure you want to re-upload transcript?",
        cancelText: "Cancel",
        confirmText: "Yes",
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (ComparisonNormalizer.string(result) === "yes") {
          this.reloadPage();
        }
      });
  }

  reloadPage(): void {
    globalThis.location.reload();
  }

  private preloadPdf(index: number): void {
    if (this.loadedBlobs[index] || !this.userTranscripts[index]) {
      return;
    }

    const url =
      this.userTranscripts[index].converted_url ||
      this.userTranscripts[index].transcript_blob_url;

    if (!url) {
      return;
    }

    this.http
      .get(url, { responseType: "blob" })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (blob) => {
          this.loadedBlobs[index] = blob;

          if (this.showConsoleLogs) {
            console.log("Preloaded PDF:", index);
          }
        },
        error: () => {
          if (this.showConsoleLogs) {
            console.warn("PDF preload failed:", index);
          }
        },
      });
  }

  private preloadAllPdfs(): void {
    if (
      !Array.isArray(this.userTranscripts) ||
      this.userTranscripts.length === 0
    ) {
      return;
    }

    this.userTranscripts.forEach((_, index) => {
      this.preloadPdf(index);
    });
  }

  clearPreviousData() {
    this.extractionService.clearExtractionResult();
    this.evaluationService.clearEvaluationResult();
    this.equivalencyService.clearEquivalencyResult();
    this.feedbackService.clearFeedback();
    this.docxPreviewStateByTranscript = {};
    this.activeTab = "";
    this.disableAllTabs();
  }

  onExtractionEditLockChange(locked: boolean): void {
    this.extractionEditLocked = locked;
  }

  onMultiEquivalencyEditLockChange(locked: boolean): void {
    this.multiEquivalencyEditLocked = locked;
  }

  isProcessTabDisabled(
    stage: "extraction" | "evaluation" | "equivalency",
  ): boolean {
    if (this.multiEquivalencyValidationLocked) {
      return true;
    }

    if (!this.tabsState[stage]) {
      return true;
    }

    if (
      this.extractionEditLocked &&
      ComparisonNormalizer.string(stage) !== "extraction"
    ) {
      return true;
    }

    if (
      this.multiEquivalencyEditLocked &&
      ComparisonNormalizer.string(stage) !== "equivalency"
    ) {
      return true;
    }

    return false;
  }

  ngOnDestroy(): void {
    // Cancel any in-flight iframe-refresh timers to prevent post-destroy refresh() calls
    this.pendingRefreshTimers.forEach((id) => clearTimeout(id));
    this.pendingRefreshTimers.clear();
    this.pdfViewerRetryCount.clear();

    // Cancel any pending tab-switch debounce timer
    if (this.tabSwitchDebounceTimer !== null) {
      clearTimeout(this.tabSwitchDebounceTimer);
      this.tabSwitchDebounceTimer = null;
    }

    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();

    this.extractionService.disconnect();
    this.equivalencyService.disconnect();
    this.evaluationService.disconnect();
    this.dataService.disconnect();

    //clear retry connections if any
    this.extractionService.disconnectRetry();
    this.equivalencyService.disconnectRetry();
    this.evaluationService.disconnectRetry();
    this.dataService.disconnectRetry();
  }
}
